import React from 'react';
import MultiDataSourceTopChartsPage from '../components/MultiDataSourceTopChartsPage';
import useTopChartsActiveUsersNotifications from '../_hooks/useTopChartsActiveUsersNotifications';
import { MultiDataSourceTopChartsPageType, MultiDataSourceTopChartsPageConfigMapping } from '../_config/pageConfigs';

import type { IMultiDataSourceTopChartsPageConfig } from '@intelligence/v3/pages/TopCharts/MobileGames/types';

const pageConfig = MultiDataSourceTopChartsPageConfigMapping[MultiDataSourceTopChartsPageType.ActiveUsers];

interface IActiveUsersProps {
  /** Mobile Games 入口传入独立的筛选器继承作用域；复用页面不传。 */
  pageId?: string;
  /**
   * 页面打点配置键
   */
  pageLogConfigKey?: string;
  /**
   * 页面下载打点配置键
   */
  downloadLogConfigKey?: string;
  /**
   * 禁用筛选器和游戏选择跨Tab继承
   * 当为 true 时，切换Tab不会继承Redux中的筛选器值和游戏选择
   * 默认为 false（保持现有继承行为）
   */
  disableInheritance?: boolean;
  /**
   * 禁用筛选器分组渲染
   * 当为 true 时，仅禁用 filterGroups 布局，filterKeyList 仍保持真实筛选器顺序
   * 用于不需要按数据源分组的复用场景
   * 默认为 false（保留 Top Charts 的分组结构）
   */
  disableFilterGrouping?: boolean;
}

const mergePageConfig = (pageConfig: IMultiDataSourceTopChartsPageConfig, props: IActiveUsersProps) => {
  const { pageLogConfigKey, downloadLogConfigKey, disableFilterGrouping } = props;
  const filterCfg = disableFilterGrouping
    ? {
      ...pageConfig.filterCfg,
      filterGroups: undefined,
    }
    : pageConfig.filterCfg;
  return {
    ...pageConfig,
    filterCfg,
    pageLogKey: pageLogConfigKey || pageConfig.pageLogKey,
    downloadLogKey: downloadLogConfigKey || pageConfig.downloadLogKey,
  };
};

const ActiveUsers: React.FC<IActiveUsersProps> = (props) => {
  const { disableInheritance, pageId } = props;
  const { showFirstGuide, showFirstDownLoadBubble, setShowFirstDownLoadBubble } =
    useTopChartsActiveUsersNotifications();

  return (
    <MultiDataSourceTopChartsPage
      showFirstGuide={showFirstGuide}
      showFirstDownLoadBubble={showFirstDownLoadBubble}
      setShowFirstDownLoadBubble={setShowFirstDownLoadBubble}
      pageConfig={mergePageConfig(pageConfig, props)}
      pageId={pageId}
      disableInheritance={disableInheritance}
    />
  );
};

export default ActiveUsers;
